"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsTheme = void 0;
/**
 * @public
 */
var TeamsTheme;
(function (TeamsTheme) {
    TeamsTheme["HighContrast"] = "teamsHighContrastTheme";
    TeamsTheme["Dark"] = "teamsDarkTheme";
    TeamsTheme["Default"] = "teamsTheme";
})(TeamsTheme = exports.TeamsTheme || (exports.TeamsTheme = {}));
//# sourceMappingURL=constants.js.map